// vzhlad_predajne_v2 (20. 10. 2026, ústava 61.10): starý oranžový panel/akcent nahradený hodnotami témy — 2 miest
// PredajnaObjednavka — OBJEDNÁVKA V PREDAJNI (Mirko GO 25.8.2026, pre-flight schválený)
// ════════════════════════════════════════════════════════════════════
// 🔴 ROVNAKÝ DIZAJN A NÁLEŽITOSTI AKO PREDAJŇOVÁ CP (Mirko: „všetky náležitosti zober z predajňa CP",
//    ústavné 103.F/56 — zdieľané Ui, master-detail, brand rám, StatusTag, RowMenu, HistoryPanel,
//    ochrana neuložených zmien, PluCell našepkávač z PLU cenníka).
// ROZDIELY oproti CP (ústava 124):
//   1. VLASTNÁ KARTA — samostatné tabuľky `predajna_obj(_lines)`, vlastný rad čísel OBP-RR-NNNN.
//   2. Položky sa zadávajú CEZ MKsoft KÓDY — z cenníka sa ťahá PLU aj KÓD DODÁVATEĽA.
//   3. Cena = NÁKUPNÁ (bez DPH). Žiadne cenové hladiny — tie patria do CP.
//   4. DVE PDF: „pre KAMIR" (s PLU + kódmi dodávateľa + cenami) a „pre zákazníka" (bez nich),
//      aby si zákazník nevedel tovar rýchlo dohľadať sám.
//   5. JAZYK DOKLADU sk/pl — DPRS/WELTA/MAŁEK/KALETA sú poľské firmy, PDF aj e-mail idú po poľsky.
//   6. PREKLOPIŤ NA ZÁKAZNÍKA → vytvorí predajňovú CP; ceny sa neprenášajú (doplní obsluha).
import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react'
import { fetchAuth } from '../auth/fetchAuth.js'
import { useToast } from '../components/Toast.jsx'
import { KontaktnaOsoba } from '../components/KontaktyPartnera.jsx'   // p97 — ústava 131.10.A, jeden blok kontaktnej osoby
import { setDirty as setGuardDirty, isAnyDirty, pripravDokument, otvorDokument } from '../hooks/unsavedGuard.js'   // p97 — doklad = obrazovka (ústava 67.15)
import { useAuth } from '../auth/AuthContext.jsx'
import { COLORS, TYPO, SPACE, RADIUS, TINT, todayLocal, hladaj, SK } from '../theme.js'   // CAS_ODOSLANIA_V1
import NoviCustomerDialog from '../components/NoviCustomerDialog.jsx'
import SendCustomerDialog from '../components/SendCustomerDialog.jsx'
import { Field, FieldGrid, inp } from '../components/DocFields.jsx'
import StatusTag from '../components/StatusTag.jsx'
import { SearchInput, FilterChips, KpiRow, KpiCard, SearchableSelect, ListRow, ListStatusBar, Tabs } from '../components/Ui.jsx'
import { HistoryPanel } from '../components/HistoryPanel.jsx'
import RowMenu from '../components/RowMenu.jsx'
import { useListKeyboard } from '../hooks/useListKeyboard.js'
import { Btn, BtnAdd } from '../components/Btn.jsx'

const API = '/api/predajna-obj'
const eur = (x) => (Number(x) || 0).toLocaleString('sk-SK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'
const n2 = (x) => Math.round((Number(x) || 0) * 100) / 100
const TODAY = () => todayLocal()
const numOr = (v, def) => { const s = String(v ?? '').trim(); if (s === '') return def; const n = Number(s); return Number.isFinite(n) && n >= 0 ? n : def }

const FILTERS = [
  { key: 'all',       label: 'Všetko',    color: COLORS.muted },
  { key: 'koncept',   label: 'Koncept',   color: COLORS.muted },
  { key: 'odoslana',  label: 'Odoslané',  color: COLORS.nav },
  { key: 'potvrdena', label: 'Potvrdené', color: COLORS.add },
  { key: 'dodana',    label: 'Dodané',    color: COLORS.add },
]
const STAVY = [
  { v: 'koncept', l: 'Koncept' }, { v: 'odoslana', l: 'Odoslaná' }, { v: 'potvrdena', l: 'Potvrdená' },
  { v: 'dodana', l: 'Dodaná' }, { v: 'zrusena', l: 'Zrušená' },
]
const JAZYKY = [{ v: 'sk', l: 'Slovensky' }, { v: 'pl', l: 'Poľsky (PL)' }]
// Poľskí dodávatelia — predvolí sa poľština (Mirko 25.8., ústava 124.9)
const PL_RE = /dprs|welta|ma[łl]ek|kaleta/i

const dodLabel = (o) => o.dodavatel || '— bez dodávateľa —'
const custLabel = (c) => c.name + (c.ico ? ' · IČO ' + c.ico : '') + ' (' + c.id + ')'

const ROW_GRID = {
  display: 'grid',
  gridTemplateColumns: '1fr 148px 60px 84px 104px 96px 76px',
  gap: 4, padding: '6px 10px',
}
const freshLine = () => ({ _k: Math.random().toString(36).slice(2), id: null, plu: '', kod: '', name: '', name2: '', unit: 'ks', qty: 1, price: 0, sklad: null })

// ── Našepkávač PLU (zhodný s predajňovou CP; navyše vracia kód dodávateľa) ──
function PluCell({ line, onPick, onName }) {
  const [q, setQ] = useState('')
  const [res, setRes] = useState([])
  const [open, setOpen] = useState(false)
  const [stav, setStav] = useState('')
  const [rect, setRect] = useState(null)
  const box = useRef(null)
  const inputRef = useRef(null)

  const measure = useCallback(() => {
    if (!inputRef.current) return
    const r = inputRef.current.getBoundingClientRect()
    setRect({ top: r.bottom + 2, left: r.left, width: Math.max(r.width, 420) })
  }, [])

  useEffect(() => {
    if (!open) return
    const term = q.trim()
    if (term.length < 2) { setRes([]); setStav(''); return }
    setStav('hladam')
    const t = setTimeout(async () => {
      try {
        const r = await fetchAuth('/api/plu-cennik/search?q=' + encodeURIComponent(term))
        if (!r.ok) { setRes([]); setStav(r.status === 403 ? 'chyba403' : 'chyba'); measure(); return }
        const rows = await r.json()
        const arr = Array.isArray(rows) ? rows : []
        setRes(arr); setStav(arr.length ? '' : 'prazdne'); measure()
      } catch (_) { setRes([]); setStav('chyba'); measure() }
    }, 220)
    return () => clearTimeout(t)
  }, [q, open, measure])

  useEffect(() => {
    if (!open) return
    const h = () => measure()
    window.addEventListener('scroll', h, true); window.addEventListener('resize', h)
    return () => { window.removeEventListener('scroll', h, true); window.removeEventListener('resize', h) }
  }, [open, measure])

  useEffect(() => {
    const h = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false) }
    document.addEventListener('mousedown', h); return () => document.removeEventListener('mousedown', h)
  }, [])

  return (
    <div ref={box} style={{ position: 'relative', minWidth: 0 }}>
      <input ref={inputRef} value={line.name}
        placeholder="názov alebo číslo PLU (min. 2 znaky)…"
        onChange={e => { onName(e.target.value); setQ(e.target.value); setOpen(true); measure() }}
        onFocus={() => { if (!line.plu) { setQ(line.name); setOpen(true); measure() } }}
        style={{ ...inp, fontWeight: TYPO.weights.medium }} />
      {line.plu ? <div style={{ fontSize: 10.5, color: COLORS.muted, fontFamily: TYPO.mono, marginTop: 1 }}>PLU {line.plu}{line.sklad != null ? ' · sklad A: ' + line.sklad : ''}</div> : null}
      {open && rect && (res.length > 0 || stav) && (
        <div style={{ position: 'fixed', zIndex: 4000, top: rect.top, left: rect.left, width: rect.width, maxHeight: 300, overflowY: 'auto', background: '#fff', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, boxShadow: '0 10px 28px rgba(0,0,0,0.18)' }}>
          <div style={{ padding: '4px 9px', fontSize: 10.5, color: COLORS.muted, borderBottom: `1px solid ${COLORS.line}`, background: COLORS.bgSoft }}>
            {stav === 'hladam' ? 'Hľadám v cenníku…'
              : stav === 'prazdne' ? 'Žiadna zhoda v PLU cenníku — názov môžeš napísať ručne.'
              : stav === 'chyba403' ? 'Na PLU cenník nemáš oprávnenie (rola).'
              : stav === 'chyba' ? 'Cenník sa nepodarilo načítať — skús znova.'
              : res.length + ' nájdených · nákupné ceny sú BEZ DPH'}
          </div>
          {res.map(r => (
            <button key={r.plu} type="button" onClick={() => { onPick(r); setOpen(false); setRes([]); setStav('') }}
              style={{ display: 'block', width: '100%', textAlign: 'left', padding: '6px 9px', border: 'none', borderBottom: `1px solid ${COLORS.line}`, background: '#fff', cursor: 'pointer', fontFamily: 'inherit' }}>
              <div style={{ fontSize: TYPO.sizes.sm, fontWeight: TYPO.weights.medium, color: COLORS.text }}>{r.name}</div>
              <div style={{ fontSize: 10.5, color: COLORS.muted, fontFamily: TYPO.mono }}>
                PLU {r.plu} · {r.mj || 'ks'}{r.kod ? ' · kód ' + r.kod : ''} · nákup {eur(r.cena_nakup)} · sklad A {r.sklad_a ?? 0}
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  )
}

export default function PredajnaObjednavka() {
  const toast = useToast()
  const { user } = useAuth()
  const [list, setList] = useState([])
  const [customers, setCustomers] = useState([])
  const [selId, setSelId] = useState(null)
  const [ed, setEd] = useState(null)
  const [isNew, setIsNew] = useState(false)
  const [saving, setSaving] = useState(false)
  const [loadingDetail, setLoadingDetail] = useState(false)
  const [newCustomerOpen, setNewCustomerOpen] = useState(false)
  const [newCustomerPrefill, setNewCustomerPrefill] = useState('')
  const [search, setSearch] = useState('')
  const [filter, setFilter] = useState('all')
  const [mailFor, setMailFor] = useState(null)
  const [tab, setTab] = useState('detail')
  const [baseline, setBaseline] = useState('')

  const load = useCallback(async () => {
    try {
      const r = await fetchAuth(API)
      const rows = r.ok ? await r.json() : []
      const arr = Array.isArray(rows) ? rows : []
      setList(arr); return arr
    } catch (_) { return [] }
  }, [])
  useEffect(() => { load() }, [load])
  useEffect(() => {
    fetchAuth('/api/customers').then(r => r.ok ? r.json() : []).then(d => setCustomers(Array.isArray(d) ? d : [])).catch(() => {})
  }, [])

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase()
    return list.filter(row => {
      if (filter !== 'all' && row.stav !== filter) return false
      if (!q) return true
      return Object.values(row).some(v => v != null && hladaj(String(v), q))
    })
  }, [list, search, filter])

  const kpi = useMemo(() => ({
    total: list.length,
    sent: list.filter(r => r.stav === 'odoslana' || r.stav === 'potvrdena' || r.stav === 'dodana').length,
  }), [list])

  const snap = (e) => e ? JSON.stringify({
    h: [e.partner_id, e.dodavatel, e.dodavatel_adresa, e.dodavatel_email, e.dodavatel_telefon,
        e.datum, e.dodanie_do, e.stav, e.jazyk, e.vat_rate, e.poznamka, e.interna_poznamka],
    l: (e.lines || []).map(l => [l.plu, l.kod, l.name, l.name2, l.unit, l.qty, l.price]),
  }) : ''
  const dirty = !!ed && snap(ed) !== baseline
  const smiemOdist = () => !dirty || (!docLocked && !isAnyDirty()) || window.confirm('V rozpracovanej objednávke máš neuložené zmeny.\n\nZahodiť ich a pokračovať?')

  useEffect(() => {
    if (!dirty) return
    const h = (ev) => { ev.preventDefault(); ev.returnValue = '' }
    window.addEventListener('beforeunload', h)
    return () => window.removeEventListener('beforeunload', h)
  }, [dirty])

  const blank = () => ({
    partner_id: '', dodavatel: '', dodavatel_adresa: '', dodavatel_email: '', dodavatel_telefon: '',
    cislo: '', datum: TODAY(), dodanie_do: '', stav: 'koncept', jazyk: 'sk', vat_rate: 23,
    poznamka: '', interna_poznamka: '', quote_id: '', sent_at: null, lines: [freshLine()],
  })

  const startNew = () => {
    if (!smiemOdist()) return
    const b = blank()
    setSelId(null); setIsNew(true); setTab('detail'); setEd(b); setBaseline(snap(b))
  }

  const openDetail = async (o, preskocitStraz) => {
    if (!preskocitStraz && !smiemOdist()) return
    setSelId(o.id); setIsNew(false); setTab('detail'); setLoadingDetail(true)
    try {
      const [hr, lr] = await Promise.all([fetchAuth(API + '/' + o.id), fetchAuth(API + '/' + o.id + '/lines')])
      const head = hr.ok ? await hr.json() : o
      const rows = lr.ok ? await lr.json() : []
      const lines = (Array.isArray(rows) ? rows : []).map(l => ({
        _k: 'l' + l.id, id: l.id, plu: l.plu || '', kod: l.kod_dodavatela || '', name: l.name || '', name2: l.name2 || '',
        unit: l.unit || 'ks', qty: l.qty, price: l.price, sklad: l.sklad,
      }))
      const _ed = {
        partner_id: head.partner_id || '', dodavatel: head.dodavatel || '', dodavatel_adresa: head.dodavatel_adresa || '',
        dodavatel_email: head.dodavatel_email || '', dodavatel_telefon: head.dodavatel_telefon || '',
        cislo: head.cislo || '', datum: String(head.datum || '').slice(0, 10) || TODAY(),
        dodanie_do: String(head.dodanie_do || '').slice(0, 10), stav: head.stav || 'koncept',
        jazyk: head.jazyk || 'sk', vat_rate: head.vat_rate ?? 23, poznamka: head.poznamka || '',
        interna_poznamka: head.interna_poznamka || '', quote_id: head.quote_id || '',
        sent_at: head.sent_at || null, lines: lines.length ? lines : [freshLine()],
      }
      setEd(_ed); setBaseline(snap(_ed))
    } finally { setLoadingDetail(false) }
  }
  const reopen = async (id) => { const rows = await load(); const row = rows.find(x => x.id === id); if (row) openDetail(row, true) }

  useListKeyboard({
    items: filtered, selectedId: selId,
    onSelect: (id) => { const o = filtered.find(x => x.id === id); if (o) openDetail(o) },
    onOpen: (o) => openDetail(o),
    enabled: !newCustomerOpen && !mailFor,
  })

  const setF = (k, v) => setEd(e => ({ ...e, [k]: v }))
  const setLine = (k, patch) => setEd(e => ({ ...e, lines: e.lines.map(l => l._k === k ? { ...l, ...patch } : l) }))
  const addLine = () => setEd(e => ({ ...e, lines: [...e.lines, freshLine()] }))
  const delLine = (k) => setEd(e => ({ ...e, lines: e.lines.filter(l => l._k !== k) }))
  const moveLine = (k, d) => setEd(e => {
    const i = e.lines.findIndex(l => l._k === k); const j = i + d
    if (i < 0 || j < 0 || j >= e.lines.length) return e
    const ls = [...e.lines]; const t = ls[i]; ls[i] = ls[j]; ls[j] = t
    return { ...e, lines: ls }
  })
  // Výber z PLU cenníka — doplní PLU, KÓD DODÁVATEĽA, názov, MJ, nákupnú cenu a sklad
  const pickPlu = (k, r) => setLine(k, {
    plu: String(r.plu || '').replace(/\.0+$/, ''), kod: r.kod || '', name: r.name || '',
    unit: r.mj || 'ks', price: n2(r.cena_nakup), sklad: r.sklad_a ?? 0,
  })

  const pickDodavatel = (id) => {
    const c = customers.find(x => x.id === id)
    if (!c) return
    const adr = [c.name, c.address].filter(Boolean).join('\n')
    setEd(e => ({
      ...e, partner_id: id, dodavatel: c.name || '', dodavatel_adresa: adr,
      dodavatel_email: c.email || '', dodavatel_telefon: c.phone || '',
      jazyk: PL_RE.test(String(c.name || '')) ? 'pl' : (e.jazyk || 'sk'),
    }))
  }

  const lineSum = (l) => n2((Number(l.qty) || 0) * (Number(l.price) || 0))
  const bez = useMemo(() => ed ? n2(ed.lines.reduce((a, l) => a + lineSum(l), 0)) : 0, [ed])
  const vatPct = ed ? numOr(ed.vat_rate, 23) : 23
  const dph = n2(bez * vatPct / 100)
  const docLocked = !!(ed && ed.stav && ed.stav !== 'koncept' && ed.stav !== 'zrusena')
  // p97: objednávka predajne sa hlási do spoločného registra neuložených zmien — PDF, tlač a okno Odoslať ju najprv uložia (ústava 67.15)
  useEffect(() => {
    const k = 'predajna-obj'
    setGuardDirty(k, !!ed && dirty && !docLocked, () => save(), () => { setEd(null); setIsNew(false); setSelId(null); setBaseline('') })   // straz_v3: „Zahodiť zmeny“ zavrie rozpracovanú objednávku
    return () => setGuardDirty(k, false)
  })

  const linePayload = (l, i) => ({
    sort_order: i, plu: l.plu || '', kod_dodavatela: l.kod || '', name: l.name || '', name2: l.name2 || '',
    unit: l.unit || 'ks', qty: numOr(l.qty, 0), price: numOr(l.price, 0),
    sklad: (l.sklad === null || l.sklad === undefined) ? '' : l.sklad,
  })
  const headPayload = (e) => ({
    partner_id: e.partner_id || '', dodavatel: e.dodavatel || '', dodavatel_adresa: e.dodavatel_adresa || '',
    dodavatel_email: e.dodavatel_email || '', dodavatel_telefon: e.dodavatel_telefon || '',
    datum: e.datum || TODAY(), dodanie_do: e.dodanie_do || '', stav: e.stav || 'koncept',
    jazyk: e.jazyk || 'sk', vat_rate: numOr(e.vat_rate, 23),
    poznamka: e.poznamka || '', interna_poznamka: e.interna_poznamka || '',
  })

  const save = async () => {
    if (!ed) return false
    if (!String(ed.dodavatel || '').trim()) { toast.error('Vyplň dodávateľa.'); return false }
    setSaving(true)
    try {
      const ls = ed.lines.filter(l => String(l.name || '').trim())
      if (isNew) {
        const r = await fetchAuth(API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(headPayload(ed)) })
        const o = await r.json(); if (!r.ok) throw new Error(o.error || 'Vytvorenie zlyhalo')
        for (let i = 0; i < ls.length; i++) {
          await fetchAuth(API + '/' + o.id + '/lines', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(linePayload(ls[i], i)) })
        }
        toast.success('Objednávka ' + (o.cislo || '') + ' vytvorená.')
        setIsNew(false); await reopen(o.id)
        return true
      } else {
        const hr = await fetchAuth(API + '/' + selId, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(headPayload(ed)) })
        if (!hr.ok) { const d = await hr.json(); throw new Error(d.error || 'Uloženie zlyhalo') }
        const origR = await fetchAuth(API + '/' + selId + '/lines')
        const orig = origR.ok ? await origR.json() : []
        const keep = new Set(ls.filter(l => l.id).map(l => l.id))
        for (const o of (Array.isArray(orig) ? orig : [])) {
          if (!keep.has(o.id)) await fetchAuth(API + '/' + selId + '/lines/' + o.id, { method: 'DELETE' })
        }
        for (let i = 0; i < ls.length; i++) {
          const p = linePayload(ls[i], i)
          if (ls[i].id) await fetchAuth(API + '/' + selId + '/lines/' + ls[i].id, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(p) })
          else await fetchAuth(API + '/' + selId + '/lines', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(p) })
        }
        toast.success('Uložené.')
        await reopen(selId)
        return true
      }
    } catch (e) { toast.error(e.message); return false } finally { setSaving(false) }
  }

  const delObj = async (id, label) => {
    if (!window.confirm('Zmazať objednávku ' + label + '?')) return
    const r = await fetchAuth(API + '/' + id, { method: 'DELETE' })
    const d = await r.json().catch(() => ({}))
    if (!r.ok) { toast.error(d.error || 'Mazanie zlyhalo'); return }
    toast.success('Zmazané.')
    setEd(null); setSelId(null); setIsNew(false); setBaseline(''); load()
  }

  const openPdf = (id, variant, print) => {
    const t = localStorage.getItem('kamir_token') || ''
    otvorDokument(API + '/' + id + '/pdf?variant=' + variant + '&token=' + encodeURIComponent(t) + (print ? '&print=1' : ''), toast)   // p97: najprv uložiť
  }

  // ⧉ DUPLIKÁT (ústava 57 r.3276; predajna_dup_v1, 29. 9. 2026) — nové číslo OBP, dátum dnes,
  // položky 1:1, dodávateľ ostáva (opakovaná objednávka tomu istému dodávateľovi je bežná).
  const duplikovat = async (id, cislo) => {
    if (!smiemOdist()) return
    if (!window.confirm('Vytvoriť kópiu objednávky ' + cislo + '?\n\n'
      + 'Prenesú sa položky aj dodávateľ — dostane nové číslo a dnešný dátum.\n'
      + 'Termín dodania a poznámka pre dodávateľa ostanú prázdne.')) return
    try {
      const r = await fetchAuth(API + '/' + id + '/copy', { method: 'POST' })
      const d = await r.json().catch(() => ({}))
      if (!r.ok) throw new Error(d.error || 'HTTP ' + r.status)
      toast.success('Kópia vytvorená: ' + (d.cislo || '') + ' (' + (d.lines || 0) + ' položiek)')
      await reopen(d.id)
    } catch (e) { toast.error('Kópiu sa nepodarilo vytvoriť: ' + e.message) }
  }

  const preklopit = async (id, cislo) => {
    if (!window.confirm('Preklopiť objednávku ' + cislo + ' na predajňovú CP pre zákazníka?\n\nCeny sa NEPRENESÚ — doplní ich obsluha.\nKódy dodávateľa ani nákupné ceny sa do CP nedostanú.')) return
    const r = await fetchAuth(API + '/' + id + '/preklopit', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({}) })
    const d = await r.json().catch(() => ({}))
    if (!r.ok) { toast.error(d.error || 'Preklopenie zlyhalo'); return }
    toast.success('Vytvorená CP ' + d.quote_number + ' (' + d.lines + ' položiek) — doplň ceny v Predajni → Cenové ponuky.')
    reopen(id)
  }

  const openSendMail = async (row) => { if (!(await pripravDokument(toast))) return; setMailFor({ row, to: row.dodavatel_email || '', cc: '', phone: row.dodavatel_telefon || '' }) }   // p97

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
      <KpiRow cols={2}>
        <KpiCard title="Spolu" color={COLORS.nav} value={kpi.total} />
        <KpiCard title="Odoslané" color={COLORS.add} value={kpi.sent} />
      </KpiRow>
      <div style={{ height: SPACE.md }} />

      <div style={{ display: 'grid', gridTemplateColumns: '340px 1fr', gap: SPACE.md, flex: 1, minHeight: 0 }}>
        {/* ĽAVÝ — zoznam */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, minHeight: 0 }}>
          <BtnAdd onClick={startNew}>+ Nová objednávka</BtnAdd>
          <SearchInput value={search} onChange={setSearch} placeholder="Hľadať v objednávkach…" />
          <FilterChips value={filter} onChange={setFilter} options={FILTERS} />
          <div style={{ flex: 1, overflow: 'auto', padding: 6 }}>
            {filtered.length === 0 ? <div style={{ padding: SPACE.lg, textAlign: 'center', color: COLORS.muted, fontSize: TYPO.sizes.sm }}>
              {list.length ? 'Nič nezodpovedá filtru.' : 'Zatiaľ žiadne objednávky.'}
            </div> : filtered.map(o => {
              const strip = (o.stav === 'dodana' || o.stav === 'potvrdena') ? COLORS.add : o.stav === 'zrusena' ? COLORS.muted : o.stav === 'odoslana' ? COLORS.nav : COLORS.remove
              return (
                <ListRow key={o.id} dataId={o.id} selected={selId === o.id} stripColor={strip}
                  onClick={() => openDetail(o)} onDoubleClick={() => openDetail(o)}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', gap: 6, alignItems: 'center' }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <span style={{ fontWeight: TYPO.weights.semibold, color: COLORS.text, flex: 1, minWidth: 0, whiteSpace: 'normal', wordBreak: 'break-word' }}>{dodLabel(o)}</span>
                        <StatusTag status={o.stav} />
                      </div>
                      <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: 2, fontFamily: TYPO.mono, whiteSpace: 'normal', wordBreak: 'break-word' }}>
                        {[o.cislo || o.id, String(o.datum || '').slice(0, 10).split('-').reverse().join('.'), (o.poloziek || 0) + ' pol.', eur(o.suma)].filter(Boolean).join(' · ')}
                      </div>
                      {o.sent_at ? <div style={{ fontSize: TYPO.sizes.xs, marginTop: 2, color: COLORS.add, fontWeight: TYPO.weights.semibold }}>E-mail {SK.datumCas(o.sent_at, true)}</div> : null}
                      {o.jazyk === 'pl' ? <div style={{ fontSize: TYPO.sizes.xs, marginTop: 1, color: COLORS.nav }}>doklad po poľsky</div> : null}
                    </div>
                    <RowMenu actions={[
                      { label: 'PDF pre KAMIR (s kódmi)', onClick: () => openPdf(o.id, 'kamir', false) },
                      { label: 'PDF pre zákazníka (bez kódov)', onClick: () => openPdf(o.id, 'zakaznik', false) },
                      { label: 'Tlač', onClick: () => openPdf(o.id, 'kamir', true) },
                      { label: o.sent_at ? 'Odoslať znova dodávateľovi' : 'Odoslať dodávateľovi', onClick: () => openSendMail(o) },
                      ...(o.quote_id ? [] : [{ label: 'Preklopiť na zákazníka', onClick: () => preklopit(o.id, o.cislo || o.id) }]),
                      { label: 'Duplikovať', icon: '⧉', onClick: () => duplikovat(o.id, o.cislo || o.id) },
                      { label: 'Zmazať', danger: true, onClick: () => delObj(o.id, o.cislo || o.id) },
                    ]} />
                  </div>
                </ListRow>
              )
            })}
          </div>
          <ListStatusBar>↑↓ výber · Enter otvoriť</ListStatusBar>
        </div>

        {/* PRAVÝ — editor v brand ráme */}
        <div style={{ background: COLORS.bgSoft, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.lg, minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          <div style={{ height: 4, background: COLORS.brand }} />
          {ed ? (<>
            <div style={{ display: 'flex', alignItems: 'center', gap: SPACE.md, padding: `${SPACE.sm}px ${SPACE.lg}px`, borderBottom: `1px solid ${COLORS.line}`, background: COLORS.bg, flexWrap: 'wrap' }}>
              <h2 style={{ margin: 0, fontSize: TYPO.sizes.lg, fontWeight: TYPO.weights.extra, color: COLORS.brandText }}>
                {isNew ? 'Nová objednávka' : (ed.cislo || selId)}
              </h2>
              {!isNew && ed.dodavatel && <span style={{ fontSize: TYPO.sizes.md, fontWeight: TYPO.weights.semibold, color: COLORS.text }}>{ed.dodavatel}</span>}
              {!isNew && <StatusTag status={ed.stav} />}
              {ed.jazyk === 'pl' && <span style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold, color: COLORS.nav, background: TINT.nav, borderRadius: RADIUS.sm, padding: '1px 7px' }}>PL</span>}
              {dirty && <span title="Máš neuložené zmeny" style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold, color: COLORS.remove, background: TINT.remove || 'rgba(220,38,38,0.10)', borderRadius: RADIUS.sm, padding: '1px 7px' }}>neuložené zmeny</span>}
              <div style={{ flex: 1 }} />
              {!isNew && <Btn variant="ghost" onClick={() => openPdf(selId, 'kamir', false)}>PDF (KAMIR)</Btn>}
              {!isNew && <Btn variant="ghost" onClick={() => openPdf(selId, 'zakaznik', false)}>PDF pre zákazníka</Btn>}
              {!isNew && <Btn variant="ghost" onClick={() => { const row = list.find(x => x.id === selId); if (row) openSendMail(row) }}>Poslať dodávateľovi</Btn>}
              {!isNew && !ed.quote_id && <Btn variant="ghost" onClick={() => preklopit(selId, ed.cislo || selId)}>Preklopiť na zákazníka</Btn>}
              {!isNew && <Btn variant="ghost" onClick={() => delObj(selId, ed.cislo || selId)}>Zmazať</Btn>}
              <BtnAdd onClick={save} disabled={saving || docLocked}>{saving ? 'Ukladám…' : (isNew ? 'Vytvoriť objednávku' : '✓ Uložiť')}</BtnAdd>
            </div>

            {docLocked && (
              <div style={{ padding: `${SPACE.sm}px ${SPACE.lg}px`, background: TINT.add, borderBottom: `1px solid ${COLORS.line}`, fontSize: TYPO.sizes.xs, color: COLORS.muted }}>
                Objednávka je v stave „{(STAVY.find(s => s.v === ed.stav) || {}).l || ed.stav}" — obsah je uzamknutý. Na úpravu ju vráť do stavu Koncept.
              </div>
            )}
            {ed.quote_id && (
              <div style={{ padding: `${SPACE.sm}px ${SPACE.lg}px`, background: TINT.nav, borderBottom: `1px solid ${COLORS.line}`, fontSize: TYPO.sizes.xs, color: COLORS.muted }}>
                Preklopené na cenovú ponuku pre zákazníka — <b>{ed.quote_id}</b> (Predajňa → Cenové ponuky).
              </div>
            )}

            {!isNew && (
              <div style={{ padding: `${SPACE.sm}px ${SPACE.lg}px 0`, borderBottom: `1px solid ${COLORS.line}` }}>
                <Tabs value={tab} onChange={setTab} tabs={[{ key: 'detail', label: 'Detail' }, { key: 'historia', label: 'História' }]} />
              </div>
            )}

            <div style={{ padding: SPACE.md, overflow: 'auto', flex: 1, display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
              {tab === 'historia' && !isNew ? (
                <HistoryPanel module="predajna_obj" entityId={selId} />
              ) : loadingDetail ? <div style={{ padding: SPACE.xl, textAlign: 'center', color: COLORS.muted }}>Načítavam…</div> : (<>
                <FieldGrid>
                  <Field label="Dodávateľ">
                    <div style={{ display: 'flex', gap: 6 }}>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <SearchableSelect value={ed.partner_id || ''} allowCreate
                          onChange={v => {
                            const exists = customers.some(c => c.id === v)
                            if (exists) pickDodavatel(v)
                            else if (v && v.trim()) { setNewCustomerPrefill(v.trim()); setNewCustomerOpen(true) }
                          }}
                          options={customers.map(c => ({ value: c.id, label: custLabel(c) }))}
                          placeholder="Hľadať podľa mena alebo IČO…" />
                      </div>
                      <button type="button" onClick={() => { setNewCustomerPrefill(''); setNewCustomerOpen(true) }}
                        style={{ padding: '0 12px', border: `1px solid ${COLORS.line}`, background: COLORS.bg, color: COLORS.brand, borderRadius: RADIUS.sm, cursor: 'pointer', fontWeight: TYPO.weights.semibold, fontSize: TYPO.sizes.sm, fontFamily: 'inherit', whiteSpace: 'nowrap' }}>+ Nový</button>
                    </div>
                  </Field>
                  <Field label="Názov dodávateľa na doklade">
                    <input style={inp} value={ed.dodavatel} onChange={e => setF('dodavatel', e.target.value)} />
                  </Field>
                  <Field label="Číslo objednávky">
                    <input style={{ ...inp, background: COLORS.bgSoft }} value={ed.cislo || (isNew ? '(pridelí sa po uložení)' : '')} readOnly />
                  </Field>
                  <Field label="Dátum vystavenia">
                    <input style={inp} type="date" value={ed.datum} onChange={e => setF('datum', e.target.value)} />
                  </Field>
                  <Field label="Požadované dodanie">
                    <input style={inp} type="date" value={ed.dodanie_do} onChange={e => setF('dodanie_do', e.target.value)} />
                  </Field>
                  <Field label="Stav">
                    <select style={inp} value={ed.stav} onChange={e => setF('stav', e.target.value)}>
                      {STAVY.map(s => <option key={s.v} value={s.v}>{s.l}</option>)}
                    </select>
                  </Field>
                  <Field label="Jazyk dokladu (PDF aj e-mail)">
                    <select style={inp} value={ed.jazyk} onChange={e => setF('jazyk', e.target.value)}>
                      {JAZYKY.map(j => <option key={j.v} value={j.v}>{j.l}</option>)}
                    </select>
                  </Field>
                  <Field label="DPH % (dopočíta sa k cenám bez DPH)">
                    <input style={inp} type="number" step="1" value={ed.vat_rate} onChange={e => setF('vat_rate', e.target.value)} />
                  </Field>
                  {/* p97 ústava 131.10.A: JEDEN blok kontaktnej osoby — osoba z registra partnera (dodávateľa); meno sa neukladá, ukáže ho register */}
                  <KontaktnaOsoba customerId={ed.partner_id} zamknute={docLocked} ulozMeno={false} inp={inp}
                    osoba={{ telefon: ed.dodavatel_telefon, email: ed.dodavatel_email }}
                    onZmena={o => { setF('dodavatel_email', o.email); setF('dodavatel_telefon', o.telefon) }}
                    popisy={{ osoba: 'Kontaktná osoba dodávateľa', email: 'E-mail dodávateľa (sem ide objednávka)', telefon: 'Telefón dodávateľa' }}
                    obal={(tx, pole, kl) => <Field key={kl} label={tx}>{pole}</Field>} />
                  <Field label="Adresa dodávateľa (tlačí sa na doklad)">
                    <textarea style={{ ...inp, resize: 'vertical', minHeight: 40 }} value={ed.dodavatel_adresa}
                      onChange={e => setF('dodavatel_adresa', e.target.value)} />
                  </Field>
                </FieldGrid>

                {/* POLOŽKY — zadávajú sa cez MKsoft kódy (PLU cenník) */}
                <div style={{ background: COLORS.bg, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md }}>
                  <div style={{ padding: `${SPACE.sm}px ${SPACE.md}px`, background: COLORS.bgSoft, borderBottom: `1px solid ${COLORS.line}`, display: 'flex', alignItems: 'center', gap: SPACE.md, borderRadius: `${RADIUS.md}px ${RADIUS.md}px 0 0` }}>
                    <strong style={{ fontSize: TYPO.sizes.sm }}>Položky objednávky ({ed.lines.length})</strong>
                    <span style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>ceny sú NÁKUPNÉ a BEZ DPH · kód dodávateľa sa doplní z cenníka, dá sa prepísať</span>
                    <div style={{ flex: 1 }} />
                    <BtnAdd onClick={addLine}>+ Položka</BtnAdd>
                  </div>
                  <div style={{ ...ROW_GRID, background: COLORS.bgSoft, borderBottom: `1px solid ${COLORS.line}`, fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.bold, color: COLORS.muted, textTransform: 'uppercase' }}>
                    <span>Položka (PLU)</span><span>Kód dodávateľa</span><span>MJ</span>
                    <span style={{ textAlign: 'right' }}>Množstvo</span><span style={{ textAlign: 'right' }}>Nákup/MJ bez DPH</span>
                    <span style={{ textAlign: 'right' }}>Spolu bez DPH</span><span />
                  </div>
                  {ed.lines.map((l, idx) => (
                    <div key={l._k} style={{ ...ROW_GRID, alignItems: 'start', fontSize: TYPO.sizes.sm, borderBottom: `1px solid ${COLORS.lineSoft || COLORS.line}`, background: idx % 2 ? COLORS.bgSoft : 'transparent' }}>
                      <div style={{ minWidth: 0 }}>
                        <PluCell line={l} onPick={r => pickPlu(l._k, r)} onName={v => setLine(l._k, { name: v, plu: '', kod: '', sklad: null })} />
                        <input style={{ ...inp, marginTop: 3, fontSize: 11.5, fontStyle: 'italic', color: COLORS.muted }} value={l.name2}
                          placeholder="2. riadok — poľský popis (tlačí sa pod názvom)"
                          onChange={e => setLine(l._k, { name2: e.target.value })} />
                      </div>
                      <input style={{ ...inp, fontFamily: TYPO.mono, fontSize: 11.5 }} value={l.kod} placeholder="napr. GTP 50"
                        title="Kód, pod ktorým položku vedie DODÁVATEĽ — tlačí sa len na doklad pre KAMIR"
                        onChange={e => setLine(l._k, { kod: e.target.value })} />
                      <input style={{ ...inp, textAlign: 'center' }} value={l.unit} onChange={e => setLine(l._k, { unit: e.target.value })} />
                      <input style={{ ...inp, textAlign: 'right' }} type="number" step="0.01" value={l.qty} onChange={e => setLine(l._k, { qty: e.target.value })} />
                      <input style={{ ...inp, textAlign: 'right' }} type="number" step="0.01" value={l.price} title="nákupná cena za MJ BEZ DPH"
                        onChange={e => setLine(l._k, { price: e.target.value })} />
                      <span style={{ textAlign: 'right', fontWeight: TYPO.weights.semibold, paddingTop: 6 }}>{eur(lineSum(l))}</span>
                      <div style={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                        <button type="button" onClick={() => moveLine(l._k, -1)} disabled={idx === 0} title="Posunúť vyššie"
                          style={{ border: `1px solid ${COLORS.line}`, background: '#fff', borderRadius: RADIUS.sm, cursor: idx === 0 ? 'default' : 'pointer', color: idx === 0 ? COLORS.line : COLORS.muted, padding: '0 4px', height: 26, lineHeight: '24px' }}>↑</button>
                        <button type="button" onClick={() => moveLine(l._k, 1)} disabled={idx === ed.lines.length - 1} title="Posunúť nižšie"
                          style={{ border: `1px solid ${COLORS.line}`, background: '#fff', borderRadius: RADIUS.sm, cursor: idx === ed.lines.length - 1 ? 'default' : 'pointer', color: idx === ed.lines.length - 1 ? COLORS.line : COLORS.muted, padding: '0 4px', height: 26, lineHeight: '24px' }}>↓</button>
                        <button type="button" onClick={() => delLine(l._k)} title="Zmazať položku"
                          style={{ border: `1px solid ${COLORS.line}`, background: '#fff', borderRadius: RADIUS.sm, cursor: 'pointer', color: COLORS.muted, padding: '0 5px', height: 26, lineHeight: '24px' }}>✕</button>
                      </div>
                      {l.sklad != null ? (
                        <span style={{ gridColumn: '1 / -1', fontSize: TYPO.sizes.xs, color: COLORS.muted, textAlign: 'right', paddingBottom: 4 }}>
                          sklad A pri zadaní: <b style={{ color: Number(l.sklad) <= 0 ? (COLORS.remove || '#dc2626') : COLORS.text }}>{l.sklad} {l.unit}</b>
                        </span>
                      ) : null}
                    </div>
                  ))}
                  <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 24, padding: `${SPACE.sm}px ${SPACE.md}px`, background: COLORS.bgSoft, fontSize: TYPO.sizes.sm, borderRadius: `0 0 ${RADIUS.md}px ${RADIUS.md}px` }}>
                    <span>Spolu bez DPH: <b>{eur(bez)}</b></span>
                    <span>DPH {vatPct} %: <b>{eur(dph)}</b></span>
                    <span style={{ fontSize: 15 }}>Celkom s DPH: <b>{eur(bez + dph)}</b></span>
                  </div>
                </div>

                <Field label="Poznámka na doklade — VIDÍ JU DODÁVATEĽ (tlačí sa v PDF)">
                  <textarea style={{ ...inp, resize: 'vertical', minHeight: 40 }} value={ed.poznamka}
                    placeholder="napr. Prosíme uvádzať naše PLU aj váš kód na dodacom liste."
                    onChange={e => setF('poznamka', e.target.value)} />
                </Field>
                <Field label="Interná poznámka (NIE v PDF — len pre nás)">
                  <textarea style={{ ...inp, resize: 'vertical', minHeight: 40 }} value={ed.interna_poznamka}
                    onChange={e => setF('interna_poznamka', e.target.value)} />
                </Field>

                <div style={{ display: 'flex', gap: 8 }}>
                  <BtnAdd onClick={save} disabled={saving || docLocked}>{saving ? 'Ukladám…' : (isNew ? 'Vytvoriť objednávku' : '✓ Uložiť')}</BtnAdd>
                  <Btn variant="ghost" onClick={() => { if (!smiemOdist()) return; setEd(null); setIsNew(false); setSelId(null); setBaseline('') }}>Zrušiť</Btn>
                </div>
              </>)}
            </div>
          </>) : (
            <div style={{ padding: SPACE.xl, textAlign: 'center', color: COLORS.muted }}>
              Vyber objednávku vľavo alebo vytvor <b>Novú objednávku</b>.<br />
              Položky sa zadávajú cez PLU cenník — doplní sa PLU, <b>kód dodávateľa</b>, nákupná cena a stav skladu.
              <br />Doklad pre dodávateľa má kódy aj ceny; doklad pre zákazníka ich <b>nemá</b>.
            </div>
          )}
        </div>
      </div>

      <NoviCustomerDialog
        open={newCustomerOpen}
        prefillName={newCustomerPrefill}
        onClose={() => { setNewCustomerOpen(false); setNewCustomerPrefill('') }}
        onCreated={c => {
          setCustomers(prev => [...prev, c])
          pickDodavatel(c.id)
          setNewCustomerOpen(false); setNewCustomerPrefill('')
        }}
      />

      {/* ZDIEĽANÝ dialóg odoslania — ústava 103.E/103.K (jeden systém pre celý Matrix) */}
      {mailFor && (
        <SendCustomerDialog open onClose={() => setMailFor(null)}
          title={`Odoslať objednávku ${mailFor.row.cislo || mailFor.row.id} dodávateľovi`}
          initTo={mailFor.to} initCc={mailFor.cc} phone={mailFor.phone}
          initSubject={(mailFor.row.jazyk === 'pl' ? 'Zamówienie ' : 'Objednávka ') + (mailFor.row.cislo || mailFor.row.id)}
          initText={mailFor.row.jazyk === 'pl'
            ? `Dzień dobry,\n\nw załączeniu przesyłamy zamówienie ${mailFor.row.cislo || ''}.\nProsimy o potwierdzenie dostępności, ceny oraz terminu dostawy.\n\nZ poważaniem\nKAMIR s.r.o.`
            : `Dobrý deň,\n\nv prílohe Vám posielame objednávku ${mailFor.row.cislo || ''}.\nProsíme o potvrdenie dostupnosti, ceny a termínu dodania.\n\nS pozdravom\nKAMIR s.r.o.`}
          attachmentName={`${String(mailFor.row.cislo || mailFor.row.id).replace(/[^a-zA-Z0-9_-]/g, '_')}.pdf`}
          attachmentNote="vygeneruje sa automaticky — verzia PRE KAMIR (s PLU a kódmi dodávateľa)."
          footNote={'Objednávka sa po odoslaní prepne do stavu „Odoslaná" a uzamkne.'}
          smsLabel=""
          onSend={async ({ to, cc, subject, text }) => {
            const x = await fetchAuth(API + '/' + mailFor.row.id + '/send-email', {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ email: to, cc, subject, text, variant: 'kamir' }),
            })
            const d = await x.json(); if (!x.ok) throw new Error(d.error || 'Odoslanie zlyhalo')
            toast.success('Objednávka odoslaná.')
            return { to: d.to }
          }}
          onSent={() => { const id = mailFor.row.id; setMailFor(null); reopen(id) }} />
      )}
    </div>
  )
}
